import { render, staticRenderFns } from "./icon-delete.vue?vue&type=template&id=82d7b49e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82d7b49e')) {
      api.createRecord('82d7b49e', component.options)
    } else {
      api.reload('82d7b49e', component.options)
    }
    module.hot.accept("./icon-delete.vue?vue&type=template&id=82d7b49e&", function () {
      api.rerender('82d7b49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/icons/icon-delete.vue"
export default component.exports